import React, { FC } from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Checkbox,
    ListItemText,
    OutlinedInput,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type MultiSelectFilterProps = {
    label: string;
    optionSelected?: string[];
    options: string[];
    onOptionChange: (option: string[]) => void;
    translationNamespace?: string;
};
const MultiSelectFilter: FC<MultiSelectFilterProps> = ({
    label,
    optionSelected,
    options,
    onOptionChange,
    translationNamespace,
}: MultiSelectFilterProps) => {
    const { t: translate } = useTranslation(['invoices', 'orders']);
    const handleOptionChange = (event: SelectChangeEvent<string[]>) => {
        const value = event.target.value;
        onOptionChange(typeof value === 'string' ? value.split(',') : value);
    };
    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select
                multiple
                value={optionSelected}
                onChange={handleOptionChange}
                input={<OutlinedInput label={label} />}
                renderValue={(selected) =>
                    selected
                        .map((e) => translate(`${translationNamespace ? translationNamespace : 'invoices'}:${e}`))
                        .join(', ')
                }
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        <Checkbox color="secondary" checked={optionSelected && optionSelected.indexOf(option) > -1} />
                        <ListItemText
                            primary={translate(`${translationNamespace ? translationNamespace : 'invoices'}:${option}`)}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MultiSelectFilter;
